const Sizes = [
	{'id': '1: XXSmall', 'size': 48},
	{'id': '2: XSmall', 'size': 60},
	{'id': '3: Small', 'size': 84},
	{'id': '4: Medium', 'size': 96},
	{'id': '5: Large', 'size': 120},
	{'id': '6: XLarge', 'size': 140},
	{'id': '7: XXLarge', 'size': 160},
	{'id': '8: XXXLarge', 'size': 180}
]

export default Sizes


// WEBPACK FOOTER //
// ./src/data/Sizes.js